/** @module csi/slicer/slicerColumnResizer */

define([
	'dojo/_base/declare',
	'dojo/query',
	'dojo/dom',
	"dgridNew/extensions/ColumnResizer"
], function (declare, query, dom, ColumnResizer) {

	/*
	 * Find ColumnResizer's local object "resizer" and close it.
	 * See dgrid\ColumnResizer local object "resizer"
	 */
	function hideResizer() {
		var resizerNode = $('.dgrid-column-resizer')[0];
		var resizerGuardNode = $('.dgrid-resize-guard')[0];
		resizerNode.parentNode.removeChild(resizerNode);
		resizerGuardNode.parentNode.removeChild(resizerGuardNode);
	}

	return declare(ColumnResizer, {
		/**
		 * This override standard dgrid\ColumnResizer._resizeMouseUp()
		 * In the case of future dgrid upgrade, this module should be tested and checked. If new dgrid's ColumnResized 
		 * code differ from old one - this function might require attention or even be rewritten;  
		 * Called when mouse button is released
		 * @param {Object} e
		 */
		_resizeMouseUp: function (e) {
			var columnSizes = this._columnSizes;
			var colNodes;
			var colWidths;
			var lastCol = this._getResizedColumnWidths().lastColId;

			// This is used to set all the column widths to a static size
			if (!this._resizedColumns) {
				colNodes = query('.csi-slicer-realcolumn', this.headerNode);
				colNodes = colNodes.filter(function (node) {
					return !(node.columnId in columnSizes);
				});

				colWidths = colNodes.map(function (colNode) {
					return colNode.offsetWidth;
				});

				// Set a baseline size for each column based on its original measure
				colNodes.forEach(function (colNode, i) {
					this.resizeColumnWidth(colNode.columnId, colWidths[i]);
				}, this);

				this._resizedColumns = true;
			}
			dom.setSelectable(this.domNode, true);

			var cell = this._targetCell;
			var delta = this._getResizeMouseLocation(e) - this._startX; //final change in position of resizer
			var newWidth = cell.offsetWidth + delta; //the new width after resize

			if (newWidth < this.minWidth) {
				//enforce minimum widths
				newWidth = this.minWidth;
			}

			if (this.resizeColumnWidth(cell.columnId, newWidth)) {
				if (cell.columnId !== lastCol && this.adjustLastColumn) {
					this.resizeColumnWidth(this, lastCol, 'auto');
				}
			}
			hideResizer();

			// Clean up after the resize operation
			delete this._startX;
			delete this._targetCell;
		}
	});
});
